// Content type for analytics events and content classification
export type ContentType = 'Music' | 'Serenity' | 'Audiobook';

// Maps album/category type to requested content_type values
export const getContentType = (category?: string): ContentType => {
  const c = (category || '').toLowerCase();
  if (c === 'serenity' || c === 'wellness') return 'Serenity';
  if (c === 'book' || c === 'audiobook' || c === 'wisdom') return 'Audiobook';
  return 'Music';
};
